define('SageDotCom/Components/Content/CountdownTimer',["jquery"],
    function ($) {
        function CountdownTimer(scope, endDate, itemId, daysUnit, hoursUnit, minutesUnit, secondsUnit) {
            function getTimeRemaining(endDateTime) {
                const totalTimeRemaining = Date.parse(endDateTime) - Date.parse(new Date());

                //convert millisconds to seconds, minutes, hours and days
                const seconds = Math.floor((totalTimeRemaining / 1000) % 60);
                const minutes = Math.floor((totalTimeRemaining / 1000 / 60) % 60);
                const hours = Math.floor((totalTimeRemaining / (1000 * 60 * 60)) % 24);
                const days = Math.floor(totalTimeRemaining / (1000 * 60 * 60 * 24));

                return {
                    total: totalTimeRemaining,
                    days: days,
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                };
            }

            let interval = undefined;
            function updateClock(countdown, days, hours, minutes, seconds, endTime) {
                if (isEmpty(countdown) || isEmpty(days) || isEmpty(hours) || isEmpty(minutes) || isEmpty(seconds) || isEmpty(endTime)) {
                    return;
                }

                const timer = getTimeRemaining(endTime);                                               

                if (isIntegratedTimer(countdown)) {
                    days.innerHTML = timer.days + daysUnit;
                    hours.innerHTML = ("0" + timer.hours).slice(-2) + hoursUnit;
                    minutes.innerHTML = ("0" + timer.minutes).slice(-2) + minutesUnit;
                    seconds.innerHTML = ("0" + timer.seconds).slice(-2) + secondsUnit;
                } else {
                    days.innerHTML = timer.days;
                    hours.innerHTML = ("0" + timer.hours).slice(-2);
                    minutes.innerHTML = ("0" + timer.minutes).slice(-2);
                    seconds.innerHTML = ("0" + timer.seconds).slice(-2);
                }

                if (timer.days <= 0) {
                    countdown.querySelector(".days-container").classList.add("hidden");
                    countdown.querySelector(".days-container").nextElementSibling.classList.add("hidden");
                    countdown.querySelector(".seconds-container").classList.remove("hidden");
                    countdown.querySelector(".seconds-container").previousElementSibling.classList.remove("hidden");

                } else {
                    countdown.querySelector(".days-container").classList.remove("hidden");
                    countdown.querySelector(".days-container").nextElementSibling.classList.remove("hidden");
                    countdown.querySelector(".seconds-container").classList.add("hidden");
                    countdown.querySelector(".seconds-container").previousElementSibling.classList.add("hidden");
                }


                if (timer.total <= 0) {
                    countdown.querySelector(".countdown-container").parentNode.removeChild(countdown.querySelector(".countdown-container"));

                    if (countdown.querySelector(".countdown-expired-text")) {
                        countdown.querySelector(".countdown-expired-text").classList.remove("hidden");
                    }

                    if (countdown.querySelector(".integrated-countdown-expired-text")) {
                        countdown.querySelector(".integrated-countdown-expired-text").classList.remove("hidden");
                    }

                    clearInterval(interval);
                }
            }

            function initializeClock(countdownTimer, endDateTime) {
                const countdownContainer = document.getElementById(countdownTimer);

                //Check countdown is there before getting inner content
                if (isEmpty(countdownContainer)) {
                    return;
                }

                const daysSpan = countdownContainer.querySelector(".countdown-days");
                const hoursSpan = countdownContainer.querySelector(".countdown-hours");
                const minutesSpan = countdownContainer.querySelector(".countdown-minutes");
                const secondsSpan = countdownContainer.querySelector(".countdown-seconds");

                updateClock(countdownContainer, daysSpan, hoursSpan, minutesSpan, secondsSpan, endDateTime);

                interval = setInterval(
                    function() {
                         updateClock(countdownContainer, daysSpan, hoursSpan, minutesSpan, secondsSpan, endDateTime);
                    }, 1000
                );
            }

            function isEmpty(value) {
                return value === null || typeof (value) === "undefined" || value === "";
            }

            function isIntegratedTimer(countdown) {
                var countdownParent = countdown.closest('.integrated-countdown-timer');

                return !isEmpty(countdownParent);
            }

            //Get initialTotal to confirm timer is not starting at < 0
            const initialTotal = Date.parse(endDate) - Date.parse(new Date());

            if (initialTotal <= 0) {
                const initialTimer = document.getElementById(itemId);

                if (isIntegratedTimer(initialTimer)) {
                    initialTimer.querySelector(".countdown-promo-message").classList.add("hidden");
                } else {
                    initialTimer.querySelector(".countdown-container").parentNode.removeChild(initialTimer.querySelector(".countdown-container"));
                }

                if (initialTimer.querySelector(".countdown-expired-text")) {
                    initialTimer.querySelector(".countdown-expired-text").classList.remove("hidden");
                }

                if (initialTimer.querySelector(".integrated-countdown-expired-text")) {
                    initialTimer.querySelector(".integrated-countdown-expired-text").classList.remove("hidden");
                }

                return;
            } else {
                initializeClock(itemId, endDate);
            }
        }

        CountdownTimer.init = function init(args) {
            return args.IsExperienceEditorEditing ? null : new CountdownTimer(args.scope, args.endDate, args.itemId, args.daysUnit, args.hoursUnit, args.minutesUnit, args.secondsUnit);
        };

        return CountdownTimer;
    });

